/**
 * Native Services Index
 * 
 * Exporta todos los servicios nativos de Capacitor.
 * Estos servicios son REQUERIDOS para la aprobación de Apple App Store (Directriz 4.2)
 * 
 * @module native
 */

// Servicios principales
export { pushNotificationsService } from './push-notifications.service';
export { biometricAuthService } from './biometric-auth.service';
export { hapticsService } from './haptics.service';
export { networkService } from './network.service';
export { offlineStorageService } from './offline-storage.service';
export { appLifecycleService } from './app-lifecycle.service';
export { cameraService } from './camera.service';

// Types
export type { NotificationData, ScheduledNotification } from './push-notifications.service';
export type { BiometricStatus, BiometricOptions } from './biometric-auth.service';
export type { HapticImpact, HapticNotification } from './haptics.service';
export type { NetworkStatus } from './network.service';
export type { OfflineQueueItem, CachedPractice } from './offline-storage.service';
export type { AppInfo } from './app-lifecycle.service';
export type { CameraPhoto, CameraOptions } from './camera.service';

// Inicializador de todos los servicios nativos
import { pushNotificationsService } from './push-notifications.service';
import { biometricAuthService } from './biometric-auth.service';
import { networkService } from './network.service';
import { appLifecycleService } from './app-lifecycle.service';
import { Capacitor } from '@capacitor/core';
import { Logger } from '@/core/utils';

const logger = Logger.getLogger('NativeServices');

/**
 * Inicializa todos los servicios nativos
 * Llamar una vez al iniciar la app
 */
export async function initializeNativeServices(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    logger.info('Ejecutando en web, servicios nativos limitados');
    return;
  }

  logger.info('Inicializando servicios nativos...');

  try {
    // 1. App Lifecycle (splash, status bar, etc.)
    await appLifecycleService.initialize();

    // 2. Network (para modo offline)
    await networkService.initialize();

    // 3. Push Notifications
    await pushNotificationsService.initialize();

    // 4. Biometric (solo verificar disponibilidad)
    await biometricAuthService.initialize();

    logger.info('✅ Servicios nativos inicializados correctamente');
  } catch (error) {
    logger.error('Error inicializando servicios nativos', { error });
  }
}

/**
 * Limpia todos los servicios nativos
 * Llamar al cerrar la app o logout
 */
export async function cleanupNativeServices(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    await pushNotificationsService.cleanup();
    await networkService.cleanup();
    await appLifecycleService.cleanup();
    logger.info('Servicios nativos limpiados');
  } catch (error) {
    logger.error('Error limpiando servicios nativos', { error });
  }
}




